import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { saveOrder, emptyCart } from "../function/users";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Success = () => {
  const { user } = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get("session_id");
    const token = user?.token || localStorage.getItem("token");

    const fetchSessionAndSaveOrder = async () => {
      try {
        // ดึงข้อมูล session จาก backend
        const { data } = await axios.post(
          `${process.env.REACT_APP_API}/get-stripe-session`,
          { sessionId }
        );

        const session = data.session;
        const metadata = session.metadata || {};
        const couponCode = metadata.couponCode || null;
        // ตรวจสอบ couponDiscount ให้เป็น Number
        const couponDiscount = parseFloat(metadata.couponDiscount) || 0;
        const deliveryMethod = metadata.deliveryMethod || "homeDelivery";
        const branchName = metadata.branchName || null;
        const invoiceNumber = metadata.invoiceNumber || null;

        let paymentMethod = "card"; // default

        // 1. ถ้ามี payment_method (pm_xxx) จริง
        if (data.session && data.session.payment_method) {
          const pmRes = await axios.post(
            `${process.env.REACT_APP_API}/get-stripe-payment-method`,
            { paymentMethodId: data.session.payment_method }
          );
          if (pmRes.data && pmRes.data.payment_method) {
            if (pmRes.data.payment_method.type === "promptpay") {
              paymentMethod = "promptpay";
            } else if (pmRes.data.payment_method.type === "card") {
              paymentMethod = "card";
            }
          }
        } else if (
          data.session &&
          data.session.payment_method_types &&
          data.session.payment_method_types.length === 1
        ) {
          // 2. fallback: ถ้าเลือก promptpay หรือ card แบบ single
          if (data.session.payment_method_types[0] === "promptpay") {
            paymentMethod = "promptpay";
          } else if (data.session.payment_method_types[0] === "card") {
            paymentMethod = "card";
          }
        } else if (
          data.session &&
          data.session.payment_method_types &&
          data.session.payment_method_types.includes("promptpay") &&
          data.session.payment_status === "paid"
        ) {
          // 3. fallback: ถ้าเลือก promptpay ในหน้า Stripe และจ่ายสำเร็จ
          paymentMethod = "promptpay";
        }

        await saveOrder(
          token,             // authtoken
          [],                // images
          paymentMethod,     // paymentMethod
          null,              // referenceNumber
          0,                 // discount
          0,                 // pointsUsed
          invoiceNumber,     // invoiceNumber
          couponCode,        // couponCode
          couponDiscount,    // couponDiscount
          deliveryMethod,    // deliveryMethod
          branchName         // branchName
        );
        emptyCart(token);
        dispatch({ type: "ADD_TO_CART", payload: [] });
        if (typeof window !== "undefined") localStorage.removeItem("cart");
        toast.success("บันทึกออเดอร์สำเร็จ");
        setTimeout(() => {
          navigate("/user/order-tracking");
        }, 1000);
      } catch (err) {
        console.error("Order error:", err);
        toast.error("บันทึกออเดอร์ไม่สำเร็จ");
      }
    };

    if (sessionId && token) {
      fetchSessionAndSaveOrder();
    } else {
      toast.error("ยังไม่ได้ชำระเงิน");
    }
  }, [user, dispatch, navigate]);

  return <div className="row mt-5">กำลังตรวจสอบการชำระเงิน...</div>;
};

export default Success;